import { DateTime } from 'luxon';
const isoDate = (tz, days) => {
    let dt = DateTime.utc().setZone(tz);
    if (days) {
        dt = dt.minus({ days });
    }
    return dt.toISODate();
};
function getYearMonthDayFromISO(dateInIsoFormat) {
    const date = DateTime.fromFormat(dateInIsoFormat, 'yyyy-MM-dd');
    /* eslint-disable vue/sort-keys */
    return { year: date.year, month: date.month, day: date.day };
    /* eslint-enable vue/sort-keys */
}
function isoToUTCAtCurrentTime(tz, year, month, day) {
    let current = DateTime.utc().setZone(tz);
    current = current.set({ day: day, month: month, year: year });
    return current.toUTC().toISODate();
}
function convertISODateToUTC(tz, dateInIsoFormat) {
    const dateParts = getYearMonthDayFromISO(dateInIsoFormat);
    return isoToUTCAtCurrentTime(tz, dateParts.year, dateParts.month, dateParts.day);
}
/**
 * Restrict an input to only allow for numbers and allow meta events such as copy / paste
 */
const numberKeyRestriction = (event, allowCommaPeriod = false, allowPaste = false, additionalAllowKeys = []) => {
    /**
     * A list of kyes that would be allowed for Numeric inputs
     * This list must be within function to prevent strings from being being pushed
     * such as the '.', and ','. as those should be per call
     */
    const allowedNumericKeys = [
        ...'0123456789'.split(''),
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'ArrowDown',
        'ArrowUp',
        'Shift',
        'Tab',
        ...additionalAllowKeys,
    ];
    if (allowCommaPeriod)
        allowedNumericKeys.push('.', ',');
    // Set the available metaKeys (all, copy, cut)
    const allowedMetaKeys = ['a', 'c', 'x'];
    if (allowPaste)
        allowedMetaKeys.push('v');
    // Check for the Meta Key
    if (event.metaKey && allowedMetaKeys.includes(event.key))
        return event;
    // Final check if the key is allowed
    if (!allowedNumericKeys.includes(event.key))
        return event.preventDefault();
};
export { isoDate, isoToUTCAtCurrentTime, getYearMonthDayFromISO, convertISODateToUTC, numberKeyRestriction };
